import React from 'react'
import { Spin } from 'antd'
import TableRow from './TableRow'

const MaterialTable = ({ loading, setLoading, error, listMaterials, onReload }) => {
    const _renderTableContent = () => {
        if (listMaterials.length === 0 && !error) {
            return <tr>
                <td colSpan={5}>No data</td>
            </tr>
        }

        if (!!error) {
            return <tr>
                <td colSpan={5} className='text-danger'>{error}</td>
            </tr>
        }

        return listMaterials.length > 0 && listMaterials.map((item) => {
            return <TableRow
                key={item._id}
                item={item}
                loading={loading}
                setLoading={setLoading}
                onReload={onReload}
            />
        })
    }
    return (
        <div className='MaterialTable'>
            <Spin tip="Loading..." spinning={loading}>
                <table className="table table-striped">
                    <thead className="TableHead">
                        <tr>
                            <th className="Name">Tên</th>
                            <th className="Code">Mã nguyên vật liệu</th>
                            <th className="CodeTranfer">Mã hóa</th>
                            <th className="BrandRule">Partner sản xuất</th>
                            <th className="OrderType">Ngày cập nhật</th>
                            <th className="Actions">Hành động</th>
                        </tr>
                    </thead>
                    <tbody className="TableBody">
                        {_renderTableContent()}
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default MaterialTable